import { useEffect, useRef } from 'react';
import { isDemoMode } from '../lib/runtime';

declare global { interface Window { turnstile?: { render: (element: HTMLElement, options: { sitekey:string; callback:(token:string)=>void; 'expired-callback':()=>void; theme:'auto' }) => void } } }

export function Turnstile({ onToken }: { onToken: (token:string) => void }) {
  const host = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (isDemoMode || !host.current) return;
    const sitekey = import.meta.env.VITE_TURNSTILE_SITE_KEY;
    if (!sitekey) return;
    const render = () => window.turnstile?.render(host.current!, { sitekey, theme: 'auto', callback: onToken, 'expired-callback': () => onToken('') });
    const existing = document.querySelector<HTMLScriptElement>('script[data-turnstile]');
    if (existing) { existing.addEventListener('load', render, { once: true }); if (window.turnstile) render(); return; }
    const script = document.createElement('script'); script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; script.async = true; script.dataset.turnstile = 'true'; script.addEventListener('load', render, { once: true }); document.head.append(script);
  }, [onToken]);
  return isDemoMode ? null : <div className="turnstile" ref={host}/>;
}
